import request from '../helper/request'
// 公司信息
export function getCompanyInfo() {
  return request({
    url: '/api/getCompanyInfo/',
    method: 'post'
  })
}
export function updateCompanyInfo(data) {
  return request({
    url: '/api/updateCompanyInfo/',
    method: 'post',
    data
  })
}

// 联系人
export function getContactList() {
  return request({
    url: '/api/getContactList/',
    method: 'post'
  })
}
export function addContact(data) {
  return request({
    url: '/api/addContact/',
    method: 'post',
    data
  })
}
export function updateContact(data) {
  return request({
    url: '/api/updateContact/',
    method: 'post',
    data
  })
}
export function deleteContact(data) {
  return request({
    url: '/api/deleteContact/',
    method: 'post',
    data
  })
}

// 合作伙伴
export function getPartnerList(params = { page: 1, pageSize: 12 }) {
  return request({
    url: '/api/getPartnerList/',
    method: 'post',
    data: params
  })
}



export function addPartner(data) {
  return request({
    url: '/api/addPartner/',
    method: 'post',
    data
  })
}
export function updatePartner(data) {
  return request({
    url: '/api/updatePartner/',
    method: 'post',
    data
  })
}
export function deletePartner(data) {
  return request({
    url: '/api/deletePartner/',
    method: 'post',
    data
  })
}

// 产品
export function getProductList() {
  return request({
    url: '/api/getProductList/',
    method: 'post'
  })
}
export function getProductById(data) {
  return request({
    url: '/api/getProductById/',
    method: 'post',
    data
  })
}
export function addProduct(data) {
  return request({
    url: '/api/addProduct/',
    method: 'post',
    data
  })
}
export function updateProduct(data) {
  return request({
    url: '/api/updateProduct/',
    method: 'post',
    data
  })
}
export function deleteProduct(data) {
  return request({
    url: '/api/deleteProduct/',
    method: 'post',
    data
  })
}

// 新闻
export function fetchNewsList(params) {
  return request({
    url: '/api/getNewsList/',
    method: 'post',
    data: params
  })
}
export function getNewsById(data) {
  return request({
    url: '/api/getNewsById/',
    method: 'post',
    data
  })
}
export function getLastNews() {
  return request({
    url: '/api/getLastNews/',
    method: 'post'
  })
}
export function adminAddNews(data) {
  return request({
    url: '/api/adminAddNews/',
    method: 'post',
    data
  })
}
export function adminDeleteNews(data) {
  return request({
    url: '/api/adminDeleteNews/',
    method: 'post',
    data
  })
}

  